import { Customer } from "msd-capacity-planning-model";
export const FETCH_CUSTOMERS = "customers/fetch";
export const LOAD_CUSTOMERS = "customers/load";
export const REMOVE_CUSTOMER = "customers/remove";
export const PERSIST_CUSTOMER = "customers/persist";
export const SET_CUSTOMERS_DATE_FILTER = "customers/dateFilter/set";

export interface CustomersState {
  items: { [id: string]: Customer };
  synching: boolean;
  dateFilter?: string;
}

export interface FetchCustomersAction {
  type: typeof FETCH_CUSTOMERS;
}

export interface LoadCustomersAction {
  type: typeof LOAD_CUSTOMERS;
  items: Customer[];
  dateFilter?: string;
}

export interface RemoveCustomerAction {
  type: typeof REMOVE_CUSTOMER;
  id: string;
}

export interface PersistCustomerAction {
  type: typeof PERSIST_CUSTOMER;
  item: Customer;
}

export interface SetCustomersDateFilterAction {
  type: typeof SET_CUSTOMERS_DATE_FILTER;
  dateFilter: string;
}

export type CustomerAction =
  | FetchCustomersAction
  | LoadCustomersAction
  | RemoveCustomerAction
  | PersistCustomerAction
  | SetCustomersDateFilterAction;
